import {
  Box,
  Button,
  Flex,
  List,
  ListIcon,
  ListItem,
  Text,
} from "@chakra-ui/react";
import { FiCheck, FiStar } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { GOALS_PREMIUM_PITCH, PREVIEW_GOALS } from "../../helpers/goalPreview";
import DeadlineGoalCard from "./DeadlineGoalCard";
import RateGoalCard from "./RateGoalCard";
import YearlyGoalCard from "./YearlyGoalCard";

const PreviewCard = ({ goal }) => {
  if (goal.type === "deadline") {
    return <DeadlineGoalCard goal={goal} />;
  }
  if (goal.type === "rate") {
    return <RateGoalCard goal={goal} />;
  }
  return <YearlyGoalCard goal={goal} />;
};

/**
 * The Goals tab for free accounts: the pitch and an Upgrade call to action,
 * followed by a non-interactive preview of what the three goal types look
 * like once set.
 */
const GoalsUpgrade = () => {
  const navigate = useNavigate();

  return (
    <Box>
      <Box
        bg="#1f1600"
        border="1px solid"
        borderColor="rgba(255, 170, 0, 0.5)"
        borderRadius="xl"
        mx={{ base: 5, md: 8 }}
        my="5"
        px={{ base: 4, md: 6 }}
        py={{ base: 5, md: 6 }}
      >
        <Flex align="center" gap="3" mb="3">
          <Flex
            align="center"
            bg="rgba(255, 170, 0, 0.13)"
            borderRadius="full"
            color="#ffaa00"
            h="40px"
            justify="center"
            w="40px"
            flexShrink={0}
          >
            <FiStar aria-hidden />
          </Flex>
          <Text fontSize="xl" fontWeight="bold" lineHeight="1.2">
            {GOALS_PREMIUM_PITCH.title}
          </Text>
        </Flex>
        <Text color="gray.300" fontSize="md" mb="4">
          {GOALS_PREMIUM_PITCH.description}
        </Text>
        <List mb="5" spacing="2">
          {GOALS_PREMIUM_PITCH.points.map((point) => (
            <ListItem color="gray.200" fontSize="sm" key={point}>
              <ListIcon as={FiCheck} color="#ffaa00" />
              {point}
            </ListItem>
          ))}
        </List>
        <Button
          bg="#ffaa00"
          color="black"
          _hover={{ bg: "#ffbb33" }}
          borderRadius="full"
          onClick={() => navigate("/go-premium")}
          size="md"
          w={{ base: "100%", md: "auto" }}
        >
          Upgrade to Premium
        </Button>
      </Box>

      <Box px={{ base: 5, md: 8 }} pb="5">
        <Text
          color="gray.500"
          fontSize="sm"
          fontWeight="bold"
          letterSpacing="0.8px"
          mb="3"
          textTransform="uppercase"
        >
          Preview
        </Text>
        <Box
          aria-hidden
          opacity={0.55}
          pointerEvents="none"
          userSelect="none"
          data-testid="goals-preview"
        >
          {PREVIEW_GOALS.map((goal) => (
            <PreviewCard goal={goal} key={goal.id} />
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default GoalsUpgrade;
